module.exports = __webpack_public_path__ + "static/media/food-icon.335937f2.svg";